import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';

import cartActions from 'src/store/modules/cart/actions';

import GoToCart from './GoToCart';
import { cartItemCountSel } from 'src/store/modules/cart/selectors';
import { isLoggedInSel } from 'src/store/modules/signin';

const mapStateToProps = (state: any) => {
  return {
    itemsInCart: cartItemCountSel(state),
    isLoggedIn: isLoggedInSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getItemCount: () => dispatch(cartActions.getItemCount())
});

export const pureComponent = GoToCart;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(GoToCart));

interface IDispatchFromProps {
  getItemCount(): void;
}
